import { put, takeLatest } from "redux-saga/effects";
import { getAvailabilitySuccess, getAvailabilityFailed, getPublicSettingsSuccess, getPublicSettingsFailed, sendEmailSuccess, sendEmailFailed } from "../reducers/publicSlice";
import { createBookingSuccess, createBookingFailed } from "../reducers/publicSlice";
import { apiEndpoints } from "../../utils/api-endpoints";
import { createErrorAction } from '../reducers/errorSlice';
import { getErrorMessage } from "../../utils/helper.utils";
import axios from "../../config/axios";

// This is public request coming from the landing page
function* createBooking(action: any): any {
    try {
        const response = yield axios.post(apiEndpoints.public.booking, action.payload);
        yield put(createBookingSuccess(response.data));
    } catch (error) {
        yield put(createBookingFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'public/createBooking'));
    }
}

function* getAvailability(action: any): any {
    try {
        const response = yield axios.get(apiEndpoints.public.availability, { params: action.payload });
        yield put(getAvailabilitySuccess(response.data));
    } catch (error) {
        yield put(getAvailabilityFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'public/getAvailability'));
    }
}

function* getPublicSettings(): any {
    try {
        const response = yield axios.get(apiEndpoints.public.settings);
        yield put(getPublicSettingsSuccess(response.data));
    } catch (error) {
        yield put(getPublicSettingsFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'public/getPublicSettings'));
    }
}

function* sendEmail(action: any): any {
    try {
        const response = yield axios.post(apiEndpoints.public.sendEmail, action.payload);
        yield put(sendEmailSuccess(response.data));
    } catch (error) {
        yield put(sendEmailFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'public/sendEmail'));
    }
}

export function* watchPublicSaga() {
    yield takeLatest('public/createBooking', createBooking);
    yield takeLatest('public/getAvailability', getAvailability);
    yield takeLatest('public/getPublicSettings', getPublicSettings);
    yield takeLatest('public/sendEmail', sendEmail);
}  